import { render, staticRenderFns } from "./communityData.vue?vue&type=template&id=21f2b5f0&scoped=true"
import script from "./communityData.vue?vue&type=script&lang=js"
export * from "./communityData.vue?vue&type=script&lang=js"
import style0 from "./communityData.vue?vue&type=style&index=0&id=21f2b5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f2b5f0",
  null
  
)

export default component.exports